/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './organism.reducer';

export const OrganismDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const organismEntity = useAppSelector(state => state.organism.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="organismDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.organism.detail.title">Organism</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.organism.id">Id</Translate>
            </span>
          </dt>
          <dd>{organismEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.organism.name">Name</Translate>
            </span>
          </dt>
          <dd>{organismEntity.name}</dd>
          <dt>
            <span id="genus">
              <Translate contentKey="tinyMedicRestApp.organism.genus">Genus</Translate>
            </span>
          </dt>
          <dd>{organismEntity.genus}</dd>
          <dt>
            <span id="species">
              <Translate contentKey="tinyMedicRestApp.organism.species">Species</Translate>
            </span>
          </dt>
          <dd>{organismEntity.species}</dd>
          <dt>
            <span id="strain">
              <Translate contentKey="tinyMedicRestApp.organism.strain">Strain</Translate>
            </span>
          </dt>
          <dd>{organismEntity.strain}</dd>
          <dt>
            <span id="habitat">
              <Translate contentKey="tinyMedicRestApp.organism.habitat">Habitat</Translate>
            </span>
          </dt>
          <dd>{organismEntity.habitat}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.organism.notes">Notes</Translate>
            </span>
          </dt>
          <dd>{organismEntity.notes}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.organism.active">Active</Translate>
            </span>
          </dt>
          <dd>{organismEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.organism.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{organismEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.organism.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{organismEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.organism.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{organismEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.organism.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{organismEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.organism.type">Type</Translate>
          </dt>
          <dd>{organismEntity.type ? organismEntity.type.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.organism.clinicalSignificance">Clinical Significance</Translate>
          </dt>
          <dd>{organismEntity.clinicalSignificance ? organismEntity.clinicalSignificance.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/organism" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/organism/${organismEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default OrganismDetail;
